/* GOODNIGHT PLUSH (copie Artemis Clo, 06/10/2026) : bloc « Special offer at 50% off today ».
   1. Prix : barre = prix REEL du produit (rendu par le bloc natif), prix du jour = prix reel moins le taux
      lu dans data-gp-taux, rendu depuis le metachamp boutique custom.offre_remise_pourcent, lui-meme ecrit
      par offre_50.py A PARTIR de la remise automatique reellement en place. Sans taux : rien n'est reecrit.
   2. Fiche produit : une carte dont le produit est deja au panier disparait ; plus aucune carte = plus de
      titre. (Dans le tiroir, c'est le bloc natif qui le fait : cross-sell.js, classe .hidden.)
   Le tiroir se re-rend a chaque mise a jour : on repasse a chaque mutation du DOM. */
(function () {
  function taux() {
    var e = document.querySelector('[data-gp-taux]');
    return e ? parseInt(e.getAttribute('data-gp-taux'), 10) || 0 : 0;
  }
  function fmt(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2); }
  }
  // Idempotent et sans drapeau : le prix reel est memorise sur l'element (data-ac-reel) au premier
  // passage ; si le bloc natif ou un re-rendu du tiroir remet le texte d'origine, on le reecrit.
  // 🔴 06/10 : le tiroir montrait « £29.90 » seul sur mobile (Enzo). Le taux n'etait rendu que dans le
  //    tiroir NON vide, et un drapeau posé une fois empechait toute reprise. Corrige ici et dans le Liquid.
  function poser() {
    var t = taux();
    if (!(t > 0)) return;
    document.querySelectorAll('.gp-xc .prices').forEach(function (b) {
      var p = b.querySelector('.price'), c = b.querySelector('.compare-at-price');
      if (!p || !c) return;
      var reel = parseInt(p.dataset.gpReel || p.dataset.value, 10);
      if (!(reel > 0)) return;
      var remise = Math.round(reel * (100 - t) / 100);
      var tp = fmt(remise), tc = fmt(reel);
      if (p.textContent.trim() !== tp) { p.dataset.gpReel = reel; p.dataset.value = remise; p.textContent = tp; }
      if (c.textContent.trim() !== tc) { c.dataset.value = reel; c.textContent = tc; }
    });
  }
  function surLaFiche() {
    return Array.prototype.filter.call(document.querySelectorAll('.gp-xc'), function (b) { return !b.closest('cart-drawer'); });
  }
  function synchroniser() {
    var cartes = surLaFiche();
    if (!cartes.length) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var dedans = {};
        (c.items || []).forEach(function (i) { dedans[i.handle] = true; });
        var visibles = 0;
        cartes.forEach(function (b) {
          var x = b.querySelector('cross-sell-component');
          var cache = !!(x && dedans[x.getAttribute('data-product-handle')]);
          b.classList.toggle('gp-xc-cache', cache);
          if (!cache) visibles++;
        });
        var titre = document.querySelector('.gp-xc-titre');
        if (titre) titre.classList.toggle('gp-xc-cache', visibles === 0);
      }).catch(function () {});
  }
  var prevu = false;
  function planifier() {
    if (prevu) return;
    prevu = true;
    requestAnimationFrame(function () { prevu = false; poser(); });
  }
  function demarrer() {
    poser();
    synchroniser();
    new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', function () {
      setTimeout(synchroniser, 200);
      [0, 150, 600, 1500].forEach(function (d) { setTimeout(poser, d); });
    });
    document.addEventListener('cart:open', function () { setTimeout(poser, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
